import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_INCOME_START,
} from '../../actions/types'

import {
  updateIncomeSuccess,
  updateIncomeFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'

import {
  getLoanApplicationId,
  getAssets,
} from '../../reducers'

function* loanUpdateIncome({type, payload}) {
  const loanApplicationId = yield select(getLoanApplicationId);
  const data = payload
  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateIncomeSuccess(response))
  } else {
    yield put(updateIncomeFailure({
      income: error.response.data.income,
      errors: error.response.data.errors
    }))
  }
}

export function* watchLoanUpdateIncome() {
  yield takeLatest(UPDATE_INCOME_START, loanUpdateIncome)
}
